import { normalizeRole } from './permissions'

/** Office/Admin can assign inbox items to other users (Q3). */
export function canAssignInboxToOthers(role: string | null | undefined): boolean {
  const r = normalizeRole(role || '')
  return r === 'admin' || r === 'office'
}

/** Assignee + dispatch/manager/admin can mark tasks done (Q14). */
export function canCompleteInboxTask(
  actorRole: string | null | undefined,
  actorId: string | null | undefined,
  assigneeId: string
): boolean {
  if (!actorId) return false
  if (actorId === assigneeId) return true
  const r = normalizeRole(actorRole || '')
  return r === 'admin' || r === 'office' || r === 'field_manager'
}

export function assigneeDisplayName(user: {
  first_name?: string | null
  last_name?: string | null
  email?: string | null
}): string {
  const name = `${user.first_name || ''} ${user.last_name || ''}`.trim()
  return name || user.email || 'Unknown'
}

export function isEntityUnlinked(item: {
  customer_id?: string | null
  property_id?: string | null
  contract_id?: string | null
  job_id?: string | null
  employee_id?: string | null
  lead_id?: string | null
  proposal_id?: string | null
  customerId?: string | null
  propertyId?: string | null
  contractId?: string | null
  jobId?: string | null
  employeeId?: string | null
  leadId?: string | null
  proposalId?: string | null
}): boolean {
  return !(
    item.customer_id ||
    item.customerId ||
    item.property_id ||
    item.propertyId ||
    item.contract_id ||
    item.contractId ||
    item.job_id ||
    item.jobId ||
    item.employee_id ||
    item.employeeId ||
    item.lead_id ||
    item.leadId ||
    item.proposal_id ||
    item.proposalId
  )
}
